import IntegrationsContainer from './integrations-container';

export { IntegrationsContainer };
export * from './jobnimbus';



// WEBPACK FOOTER //
// ./src/browser/components/settings/integrations/index.js